import React from "react";

const DEFAULT_STYLE = {
  width: "100%",
  maxWidth: 960,
  marginBottom: -6
};

const DEFAULT_LARGE_STYLE = {
  marginTop: 50
};

const FULL_WIDTH_STYLE = {
  width: "100%"
};

const FULL_WIDTH_LARGE_STYLE = {};

class Banner extends React.Component {
  constructor(props) {
    super(props);
    this._shouldShowFullWidth = this._shouldShowFullWidth.bind(this);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object,
      tenant: React.PropTypes.object,
      isLarge: React.PropTypes.bool
    };
  }

  _shouldShowFullWidth() {
    let { router, tenant } = this.context;
    return (
      (router.isActive("/welcome") && tenant.welcome_show_splash_banner) ||
      (router.isActive(`/${tenant.passes_url_pathname}/buy`) &&
        tenant.welcome_show_splash_banner &&
        tenant.passes_show_splash_banner) ||
      tenant.always_show_splash_banner
    );
  }

  render() {
    let { tenant, isLarge } = this.context,
      style,
      src;

    if (this._shouldShowFullWidth()) {
      style = Object.assign(
        {},
        FULL_WIDTH_STYLE,
        isLarge && FULL_WIDTH_LARGE_STYLE
      );
      src = tenant.welcome_splash_banner_image || tenant.banner_image;
    } else {
      style = Object.assign({}, DEFAULT_STYLE, isLarge && DEFAULT_LARGE_STYLE);
      src = tenant.banner_image;
    }

    return (
      <img
        id="Eventive--banner"
        src={src ? src + "?w=1920" : undefined}
        style={style}
      />
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/app/components/partials/banner.jsx